export default __webpack_public_path__ + "static/media/petBreed1.26f2a1ff.png";